export default __webpack_public_path__ + "static/media/30.af24056d.png";